var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"98%","background":"#fff","width":"98%","margin":"10px auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setearphoneJack: _vm.setearphoneJack,
				getearphoneJack: _vm.getearphoneJack,
				setearphone: _vm.setearphone,
				getearphone: _vm.getearphone,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetearphoneJack,\n\t\t\t\tgetearphoneJack,\n\t\t\t\tsetearphone,\n\t\t\t\tgetearphone,\n\t\t\t}"}],attrs:{"id":"screan"}},[_c('img',{attrs:{"src":require("../assets/img/light/screan.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setearphoneJack: _vm.setearphoneJack,
				getearphoneJack: _vm.getearphoneJack,
				setearphone: _vm.setearphone,
				getearphone: _vm.getearphone,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetearphoneJack,\n\t\t\t\tgetearphoneJack,\n\t\t\t\tsetearphone,\n\t\t\t\tgetearphone,\n\t\t\t}"}],attrs:{"id":"ai"}},[_c('img',{attrs:{"src":require("../assets/img/ai.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setearphoneJack: _vm.setearphoneJack,
				getearphoneJack: _vm.getearphoneJack,
				setearphone: _vm.setearphone,
				getearphone: _vm.getearphone,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetearphoneJack,\n\t\t\t\tgetearphoneJack,\n\t\t\t\tsetearphone,\n\t\t\t\tgetearphone,\n\t\t\t}"}],attrs:{"id":"tou"}},[_c('img',{attrs:{"src":require("../assets/img/door/tou.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setearphoneJack: _vm.setearphoneJack,
				getearphoneJack: _vm.getearphoneJack,
				setearphone: _vm.setearphone,
				getearphone: _vm.getearphone,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetearphoneJack,\n\t\t\t\tgetearphoneJack,\n\t\t\t\tsetearphone,\n\t\t\t\tgetearphone,\n\t\t\t}"}],attrs:{"id":"necklace"}},[_c('img',{attrs:{"src":require("../assets/img/necklace/necklace.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setearphoneJack: _vm.setearphoneJack,
				getearphoneJack: _vm.getearphoneJack,
				setearphone: _vm.setearphone,
				getearphone: _vm.getearphone,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetearphoneJack,\n\t\t\t\tgetearphoneJack,\n\t\t\t\tsetearphone,\n\t\t\t\tgetearphone,\n\t\t\t}"}],attrs:{"id":"earphoneJack"}},[_c('img',{attrs:{"src":require("../assets/img/necklace/earphoneJack.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setearphoneJack: _vm.setearphoneJack,
				getearphoneJack: _vm.getearphoneJack,
				setearphone: _vm.setearphone,
				getearphone: _vm.getearphone,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetearphoneJack,\n\t\t\t\tgetearphoneJack,\n\t\t\t\tsetearphone,\n\t\t\t\tgetearphone,\n\t\t\t}"}],attrs:{"id":"earphone"}},[_c('img',{attrs:{"src":require("../assets/img/necklace/earphone.png"),"alt":""}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"button"},[_vm._v("进入CocoBlockly编程平台")]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"musicC","src":require('../assets/music/click.mp3')}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../assets/img/necklace/tips.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('img',{attrs:{"src":require("../assets/img/right.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d307b71","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/necklace.vue
// module id = null
// module chunks = 